export default [
  {
    title: 'Overview',
    icon: { icon: 'ic:outline-dashboard' },
    to: 'dashboard',
    action: 'read',
    subject: 'User',
  },
];
